//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeKnihaPLA.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Kniha PLA </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-13                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvspla) GID:(Web.Dia.Ts) V1:(ixs_pla,rok,ico,nazev,zkratka,poznamka,aktivita,ktg_akce,dat_zmena,zmenu_prov,cpps_msk,ixp_den_old,priz_az_def,priz_gen_cis,ixs_csp,priz_ram_doh) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeKnihaPLA
    export function DetailAdeKnihaPLADlg(
        parentContent: GContent,
        opt: {
            /** ixs_pla */
            ixs_pla: string | null,
            /** rok */
            rok: number | null,
            /** ico */
            ico: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdeKnihaPLA', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdeKnihaPLA#",
        ixs_pla: opt ? opt.ixs_pla : undefined,
        rok: opt ? opt.rok : undefined,
        ico: opt ? opt.ico : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeKnihaPLA
    export function SeznamAdeKnihaPLADlg(
        parentContent: GContent,
        opt: {
            /** ixs_pla */
            ixs_pla: string | null,
            /** rok */
            rok: number | null,
            /** ico */
            ico: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdeKnihaPLA', { }]

    const options = {
        ID: "AdmAdeKnihaPLA#",
        ixs_pla: opt ? opt.ixs_pla : undefined,
        rok: opt ? opt.rok : undefined,
        ico: opt ? opt.ico : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
